import { isElementWithType, isEmptyTextNode } from '../../../../DolEditor/helpers/node-filter';
import { ELEMENT_HYPER_LINK } from '../../../../DolEditor/elements/hyper-link/defaults';

export const normalizeHyperlinkNode = (node) => {
  if (node && isElementWithType(node, ELEMENT_HYPER_LINK)) {
    if (node?.text) {
      delete node.text;
    }
    if (node.children && node.children.every(isEmptyTextNode)) {
      return null;
    }
  }

  return node;
};
